import { useEffect, useRef, useState } from 'react';
import Button from 'react-bootstrap/Button';
import Offcanvas from 'react-bootstrap/Offcanvas';
import Spinner from 'react-bootstrap/Spinner';

import {GoogleMap, Marker, useLoadScript, Autocomplete, DirectionsRenderer, CircleF, MarkerF} from '@react-google-maps/api';
import { Modal } from 'react-bootstrap';

const libraries = ['places']
const mapContainerStyle = {
  width: '100%',
  height: '100%'
}
const center = {
  // lat: 46.231337985292946,
  lat: 46.2313,
  // lng: 6.073415524456243
  lng: 6.0734
}

const App2 = () => {
    const [show, setShow] = useState(false);
    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);
    const [loading, setLoading] = useState(false);
    const lstMats = [
        {
            id: 1,
            nom: 'Rue des Alpes',
            lat: 46.208789,
            lng: 6.147408,
            img: '/images/mats/1.png'
        },
        {
            id: 2,
            nom: 'Rue de Lausanne',
            lat: 46.212713,
            lng: 6.144988,
            img: '/images/mats/2.png'
        },
        {
            id: 3,
            nom: 'Place Marteau / Wilson / Plantamour',
            lat: 46.212730,
            lng: 6.152341,
            img: '/images/mats/3.png'
        },
        {
            id: 4,
            nom: 'Boulevard James Fazy 6',
            lat: 46.207601,
            lng: 6.140165,
            img: '/images/mats/4.png'
        },
        {
            id: 5,
            nom: 'Boulevard Saint-Georges 7',
            lat: 46.201471,
            lng: 6.137957,
            img: '/images/mats/5.png'
        },
        {
            id: 6,
            nom: 'Pont Saint-Georges',
            lat: 46.199004,
            lng: 6.128297,
            img: '/images/mats/6.png'
        },
        {
            id: 7,
            nom: 'Avenue du Mail',
            lat: 46.200371,
            lng: 6.139984,
            img: '/images/mats/7.png'
        },
        {
            id: 8,
            nom: 'Boulevard des Philosophes',
            lat: 46.196467,
            lng: 6.149700,
            img: '/images/mats/8.png'
        },
        {
            id: 9,
            nom: 'Boulevard du Pont-d\'Arve',
            lat: 46.195509,
            lng: 6.146858,
            img: '/images/mats/9.png'
        },
        {
            id: 10,
            nom: 'Place du Pré-l\'Evèque',
            lat: 46.202027,
            lng: 6.158082,
            img: '/images/mats/10.png'
        },
        {
            id: 11,
            nom: 'Avenue Pictet-de-Rochemont 31',
            lat: 46.200359,
            lng: 6.162472,
            img: '/images/mats/11.png'
        },
        {
            id: 12,
            nom: 'Route de Malagnou',
            lat: 46.198475,
            lng: 6.157833,
            img: '/images/mats/12.png'
        },
        {
            id: 13,
            nom: 'Place Jargonnant',
            lat: 46.201374,
            lng: 6.160792,
            img: '/images/mats/13.png'
        },
        {
            id: 15,
            nom: 'Quai du Général Guisan',
            lat: 46.203226,
            lng: 6.153618,
            img: '/images/mats/15.png'
        },
        {
            id: 16,
            nom: 'Quai Gustave Ador',
            lat: 46.204624,
            lng: 6.155655,
            img: '/images/mats/16.png'
        },
        {
            id: 17,
            nom: 'Rue de Chantepoulet',
            lat: 46.208097,
            lng: 6.143901,
            img: '/images/mats/17.png'
        },
        {
            id: 18,
            nom: 'Rue Terreaux-du-Temple',
            lat: 46.207193,
            lng: 6.141248,
            img: '/images/mats/18.png'
        },
        {
            id: 19,
            nom: 'Route de Florissant',
            lat: 46.195268,
            lng: 6.157692,
            img: '/images/mats/19.png'
        },
        {
            id: 20,
            nom: 'Boulevard du Pont-d\'Arve',
            lat: 46.194151,
            lng: 6.140757,
            img: '/images/mats/20.png'
        },
        {
            id: 21,
            nom: 'Rue de la Servette',
            lat: 46.209092,
            lng: 6.139473,
            img: '/images/mats/21.png'
        },
        {
            id: 22,
            nom: 'Rue de Saint-Jean',
            lat: 46.205468,
            lng: 6.133216,
            img: '/images/mats/22.png'
        },
        {
            id: 23,
            nom: 'Passage des Alpes',
            lat: 46.211339,
            lng: 6.141477,
            img: '/images/mats/23.png'
        },
        {
            id: 24,
            nom: 'Route de Saint-Julien',
            lat: 46.177937,
            lng: 6.135488,
            img: '/images/mats/24.png'
        },
        {
            id: 25,
            nom: 'Rond-point M-Parc',
            lat: 46.183057,
            lng: 6.134828,
            img: '/images/mats/25.png'
        },
        {
            id: 26,
            nom: 'Pont Val d\'Arve',
            lat: 46.183638,
            lng: 6.153322,
            img: '/images/mats/26.png'
        },
        {
            id: 27,
            nom: 'Pont Fontenette',
            lat: 46.186197,
            lng: 6.146501,
            img: '/images/mats/27.png'
        },
        {
            id: 28,
            nom: 'Parking PCC',
            lat: 46.181154,
            lng: 6.143015,
            img: '/images/mats/28.png'
        },
        {
            id: 29,
            nom: 'Parking Sardaigne',
            lat: 46.183803,
            lng: 6.139449,
            img: '/images/mats/29.png'
        },
        {
            id: 30,
            nom: 'Parking Octroi',
            lat: 46.187921,
            lng: 6.141329,
            img: '/images/mats/30.png'
        },
        {
            id: 31,
            nom: 'Parking Saint-Antoine',
            lat: 46.199609,
            lng: 6.151102,
            img: '/images/mats/31.png'
        },
        {
            id: 32,
            nom: 'Parking Lombard (entrée HUG)',
            lat: 46.194544,
            lng: 6.149207,
            img: '/images/mats/32.png'
        },
        {
            id: 33,
            nom: 'Parking Lombard (sortie)',
            lat: 46.193493,
            lng: 6.150473,
            img: '/images/mats/33.png'
        },
        {
            id: 34,
            nom: 'Rond-Point / Pont de la Fontenette',
            lat: 46.187340,
            lng: 6.146895,
            img: '/images/mats/34.png'
        },
        {
            id: 35,
            nom: 'Avenue de la Paix',
            lat: 46.223237,
            lng: 6.143754,
            img: '/images/mats/35.png'
        },
        {
            id: 36,
            nom: 'Route de Lausanne',
            lat: 46.227177,
            lng: 6.148492,
            img: '/images/mats/36.png'
        },
    ]
    const [selectedMat, setSelectedMat] = useState(null)
    const [hasCentered, setHasCentered] = useState(false)
    const [coords, setCoords] = useState({})
    const [distance, setDistance] = useState(0)
    const [map, setMap] = useState(/** @type google.maps.Map */ (null))
    const [directionsResponse, setDirectionsResponse] = useState(null)
    const [duration, setDuration] = useState('')  
    const [modalMat, setModalMat] = useState(null)
    const watchIdRef = useRef(null);
    const [mapLoaded, setMapLoaded] = useState(false)
    const [positionLoaded, setPositionLoaded] = useState(false)
    const {isLoaded, loadError} = useLoadScript({
        googleMapsApiKey: process.env.REACT_APP_GOOGLE_MAPS_API_KEY,
        libraries
    })
    const circleOptions = {
        strokeColor: 'black',
        strokeOpacity: 1,
        strokeWeight: 2,
        fillColor: 'blue',
        fillOpacity: 0.35,
        clickable: false,
        editable: false,
        radius: 50
    }

    // useEffect(() => {
    //     if (map && coords.lat) {
    //         map.panTo(coords)
    //         map.setZoom(18)
    //         setLoading(false)
    //     }
    // }, [coords, map])

    useEffect(() => {
        if (!navigator.geolocation) {
            console.error('La géolocation n\'est pas supportée.')
            setPositionLoaded(true)
            return
        }
        const options = {
            enableHighAccuracy: true,
            maximumAge: 0,
            timeout: 10000
        }
        watchIdRef.current = navigator.geolocation.watchPosition((position) => {
            const {latitude, longitude, accuracy} = position.coords
            const newCoords = {
                lat: latitude,
                lng: longitude
            }
            setCoords(newCoords)
            setDistance(accuracy)
            setPositionLoaded(true)
            setLoading(false)
            if (map && !hasCentered) {
                map.panTo(newCoords)
                map.setZoom(18)
                setHasCentered(true)
            }
        }, (error) => {
            console.error('Erreur de géolocalisation: ', error)
            setPositionLoaded(true)
        }, options)
        return () => {
            if (watchIdRef.current) navigator.geolocation.clearWatch(watchIdRef.current)
        }
    }, [map, hasCentered])

    const handleLocation = () => {
        if (navigator.geolocation) {
            setLoading(true)
            navigator.geolocation.getCurrentPosition((position) => {
                const {latitude, longitude, accuracy} = position.coords
                const newCoords = {lat: latitude, lng: longitude}
                console.log('lat: ' + latitude)
                console.log('lng: ' + longitude)
                console.log('accuracy: ' + accuracy)
                setCoords({lat:latitude, lng:longitude})
                setDistance(accuracy)
                // if (map) map.panTo(newCoords)
                // originRef.current.value = `lat: ${latitude.toFixed(4)}, lng: ${longitude.toFixed(4)}`
            })
        }
    }

    async function calculateRoute(destination) {
        if (!coords || !destination) return
        // eslint-disable-next-line no-undef
        const directionsService = new google.maps.DirectionsService()
        const results = await directionsService.route({
            origin: coords,
            destination: destination,
            // eslint-disable-next-line no-undef
            travelMode: google.maps.TravelMode.DRIVING,
            avoidHighways: true,
            provideRouteAlternatives: true
        })
        setDirectionsResponse(results)
        setDistance(results.routes[0].legs[0].distance.text)
        setDuration(results.routes[0].legs[0].duration.text)
    }

    function clearRoutes() {
        setDirectionsResponse(null)
        setDistance('')
        setDuration('')
        setSelectedMat(null)
    }

    if (loadError) {
        return <div>Erreur de chargement Google Maps</div>
    }
    
    if (!isLoaded) {
        return <div>Chargement de la carte...</div>
    }

    return (
        <>
            {(!mapLoaded || !positionLoaded) && (
                <div
                    style={{
                        position: 'fixed',
                        inset: 0,
                        backgroundColor: 'rgba(255, 255, 255, 0.85)',
                        zIndex: 2000,
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        flexDirection: 'column',
                    }}
                    >
                    <Spinner 
                        animation="border" 
                        role="status" 
                        variant="primary" 
                        style={{ 
                            width: 80, 
                            height: 80 
                        }} 
                    />
                    <p className="mt-3">
                        {!mapLoaded ? 'Chargement de la carte...' : 'Recherche de votre position...'}
                    </p>
                </div>
            )}
            <div className='searchBox d-flex flex-wrap flex-md-row flex-column gap-1 p-2'>
                <Button variant="primary" onClick={handleShow}>
                    Liste des mâts
                </Button>
                {/* <Button variant="secondary" onClick={handleLocation}>
                    Obtenir localisation
                </Button> */}
                <Button variant="secondary" onClick={() => {
                    if (map && coords?.lat) {
                        map.panTo(coords)
                        map.setZoom(18)
                        setHasCentered(true)
                    }
                }}>
                    Position
                </Button>
                <Button variant="secondary" onClick={clearRoutes}>
                    Effacer
                </Button>
            </div>
            
            {isLoaded ? (<GoogleMap
                    mapContainerStyle={mapContainerStyle}
                    zoom={coords ? 16 : 10}
                    onLoad={(map) => {
                        setMap(map)
                        setMapLoaded(true)
                    }}
                    options={{
                        gestureHandling: 'greedy',
                        zoomControl: true
                    }}
                >
                    {/* <Marker
                        position={coords}
                    /> */}
                    {directionsResponse && 
                        <DirectionsRenderer 
                            directions={directionsResponse} 
                            options={{suppressMarkers: true}}
                        />
                    }
                    {coords.lat && (
                        <>
                        <CircleF center={coords} options={circleOptions} />
                        <MarkerF 
                            position={coords} 
                            onClick={() => setModalMat(selectedMat)}
                            icon={{
                                // eslint-disable-next-line no-undef
                                path: google.maps.SymbolPath.CIRCLE,
                                scale: 6,
                                fillColor: "blue",
                                fillOpacity: 1,
                                strokeColor: "black",
                                strokeWeight: 2,
                            }}
                        />
                        </>
                    )}
                    {selectedMat && (
                        <MarkerF
                            position={{lat:selectedMat.lat, lng: selectedMat.lng}}
                            onClick={()=>setModalMat(selectedMat)}
                        />
                    )}
                </GoogleMap>
                ) : (
                    <div className='text-center mt-4'>Chargement de la carte ...</div>
                )
            }

            <Offcanvas show={show} onHide={handleClose}>
                <Offcanvas.Header closeButton>
                <Offcanvas.Title>Liste des mâts</Offcanvas.Title>
                </Offcanvas.Header>
                <Offcanvas.Body>
                <select 
                    className='form-select'
                    onChange={(e) => {
                        const m = lstMats.find(mat => mat.id === parseInt(e.target.value))
                        if (m) {
                            setSelectedMat(m)
                            calculateRoute({lat: m.lat, lng: m.lng})
                            setShow(false)
                        }
                    }}
                >
                    <option key={'pas de mat'}>Choisir un mât</option>
                    {lstMats.map((mat, key) => (
                        <option key={key}>
                            {mat.id}: {mat.nom}
                        </option>
                    ))}
                </select>
                </Offcanvas.Body>
            </Offcanvas>

            <Modal show={!!modalMat} onHide={()=>setModalMat(null)}>
                <Modal.Header closeButton>
                    <Modal.Title>{selectedMat ? selectedMat.nom : 'Pas de mât'}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <img 
                        src={selectedMat ? selectedMat.img : '/images/mats/1-4.jpeg'}
                        alt='mat'
                        style={{width:'100%',borderRadius:8}}
                    />
                </Modal.Body>
                <Modal.Footer>
                    <Button variant='secondary' onClick={() => setModalMat(null)}>
                        Fermer
                    </Button>
                </Modal.Footer>
            </Modal>
        </>
    )
}

export default App2
